/** @format */

import {createContext} from 'react'
const NodeContext=createContext(null)
export const NodeProvider=NodeContext.Provider
export default NodeContext
